import Flickity from 'flickity-imagesloaded';
// import 'flickity-imagesloaded';
import { getRTL } from '../../../../design3/asset-build/js/custom/_utils';
import debounce from 'lodash/debounce';
import { getStore } from '../../../../design3/asset-build/js/custom/stores';
import { autorun } from 'mobx';

const baseClass = 'AccommodationsListing';
const fclClass = 'FilteredColumnsList';

const isRTL = getRTL();

const selectors = {
	base: `.${baseClass}`,
	card: `.${baseClass}-card`,
	carouselContainer: `.${baseClass}-card-imageCarousel`,
	slide: `.${baseClass}-card-imageCarousel-slide`,
	nav: `.${baseClass}-card-imageCarousel-navigation`,
	currentSlideNumber: `.${baseClass}-card-imageCarousel-pagination--currentSlideNumber`,
	nextButton: `.${baseClass}-card-imageCarousel-pagination--next`,
	prevButton: `.${baseClass}-card-imageCarousel-pagination--prev`,
	filteredColumnsList: `.${baseClass} .${fclClass}`,
	filter: `.${fclClass}-filter`,
	columnsButton: `.${fclClass}-displayButtons--columns`,
	listButton: `.${fclClass}-displayButtons--list`,
};

const initCard = $card => {
	const $slides = $card.find(selectors.slide);
	const $nextButton = $card.find(selectors.nextButton);
	const $prevButton = $card.find(selectors.prevButton);
	const $nav = $card.find(selectors.currentSlideNumber);

	//Flickity Setup
	$slides.css('height', '');
	if ($slides.length > 1) {
		const $carouselContainer = $card.find(selectors.carouselContainer);
		const options = {
			cellAlign: 'center',
			pageDots: false,
			prevNextButtons: false,
			rightToLeft: isRTL,
			wrapAround: true,
			selectedAttraction: 0.075,
			friction: 0.8,
			draggable: true,
			adaptiveHeight: false,
			resize: true,
			percentPosition: true,
			imagesLoaded: true,
		};
		$carouselContainer.addClass(`${baseClass}--flickity`);
		const flickity = new Flickity($carouselContainer.get(0), options);
		$carouselContainer.attr('tabindex', '');
		//Navigation Listeners
		$nav.text(`1 ${isRTL ? '\\' : '/'} ${$nav.data('numberOfSlides')}`);

		$nextButton.on('click', () => {
			flickity.select(flickity.selectedIndex + 1, true);
		});

		$prevButton.on('click', () => {
			flickity.select(flickity.selectedIndex - 1, true);
		});

		flickity.on('change', function (index) {
			$nav.text(`${index + 1} ${isRTL ? '\\' : '/'} ${$nav.data('numberOfSlides')}`);
		});

		return flickity;
	} else {
		return false;
	}
};

const initFclListeners = ($fcl, allFlickityInstances) => {
	const resizeAllFlickityInstances = () => {
		allFlickityInstances.forEach(flickity => {
			$(flickity.viewport).css('height', '');
			flickity.resize();
		});
	};

	$fcl.on('layoutChange', resizeAllFlickityInstances);
	$fcl.on('filterChange', resizeAllFlickityInstances);
	$(window).on('resize', debounce(resizeAllFlickityInstances));
};

export default async function initAccommodatonsListing() {
	let allFlickityInstances = [];
	$(selectors.card).each((index, card) => {
		const flickityInstance = initCard($(card));
		if (flickityInstance) {
			allFlickityInstances.push(flickityInstance);
		}
	});

	$(selectors.filteredColumnsList).each((index, fcl) => {
		initFclListeners($(fcl), allFlickityInstances);
	});

	const availabilityStore = await getStore('availabilityStore');

	// this handles removing this server side listing component
	// when the booking flow component is setup
	autorun(
		async () => {
			if (availabilityStore.results || availabilityStore.fetching || availabilityStore.error) {
				document.querySelector('html').classList.add('HideStatic');
			}
		},
		{
			onError: error => {
				//shouldn't error but just in case we want to show the accomodations
				document.querySelector('html').classList.remove('HideStatic');
			},
		}
	);
}
